module.exports = "/_next/static/images/salary-advance-db45e3331098009484e26bafeeda82f4.svg";